import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity , Image} from "react-native";

import Config from "../../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../../Components/Toast";
import Loading from "../../Components/Loading";
import {useFocusEffect} from "@react-navigation/native";

const Tamrin =({navigation})=>{

    let [data, setData] = React.useState(false);
    // React.useEffect(() => {
    //     getData();
    // },[navigation]);


    useFocusEffect(
        React.useCallback(() => {
            getData();
        }, [])
    );


    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/repeat`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Text style={styles.title}>
                    تمرین و تکرار
                </Text>
            </View>
            <ScrollView >
                <View style={styles.content}>
                    {data ?
                        <>
                            {data.results.map( (item,index)=>

                                <TouchableOpacity onPress={()=>navigation.navigate('ExamTamrin',{category_id : item.category.id})} key={index} style={styles.item}>
                                    <Text style={styles.name}> {item.category.name}</Text>
                                    <View style={styles.media}>
                                        <Image
                                            style={styles.img}
                                            source={{uri : `${Config.base}/${item.category.picture}`}} />
                                        <View style={styles.badge}>
                                            <Text style={styles.badgetext}>{item.falses}</Text>
                                        </View>

                                    </View>
                                </TouchableOpacity>

                            )}

                        </>
                        :
                        <Loading/>
                    }

                </View>
            </ScrollView>

        </View>
    );
}

const styles = StyleSheet.create({
    name : {
        fontSize: RFValue(16),
        fontFamily : 'yk',
        color: 'white',
    },
    badgetext : {
        fontSize: RFValue(14),
        fontFamily : 'ykb',
        color: 'white',
        textAlign: 'center',
    },
    badge : {
        justifyContent: 'center',
        alignItems : "center",
      position: "absolute",
        top: RFValue(-26),
        left: RFValue(-28),
        backgroundColor : '#D90000',
        borderRadius : RFValue(22),
        width : RFValue(22),
        padding : RFValue(2),
    },

    content : {
        paddingHorizontal: RFValue(20),
      flex : 1,
    },
    item : {
        borderColor : '#373C6A',
        borderWidth: 1,
        borderRadius : RFValue(10),
        flexDirection : 'row',
        padding : RFValue(20),
        marginTop : RFValue(20),
        justifyContent : 'space-between',
        alignItems: 'center',
    },
    img : {
        width : RFValue(45),
        height : RFValue(45),
    },



    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(14),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(18),
        fontFamily : 'ykb',
        color: 'white',
    }
})


export default Tamrin